export enum PROFESSION_TYPES {
  SCOUT = "scout",
  BLACKSMITH = "blacksmith"
}

export enum SCOUT_ABILITY_TYPES {
  MINING_SPEED = "mining speed",
  INTUITION = "intuition",
  ENDURANCE = "endurance"
}

export enum BLACKSMITH_ABILITY_TYPES {
  RUNE_MASTERY = "Rune Mastery", // Increase the probability of successful rune crafting in % by 0.5% per level
  RUNE_FORGER = "Rune Forger", // Decrease the cost of rune crafting in % by 0.5% per level
  FORGE_EFFICIENCY = "Forge Efficiency" // Decrease the cost of shovel crafting % by 0.5% per level
}
